export default "__VITE_ASSET__C807qdFi__"